const SITE_NAME = "Dr. Vicky Jain | Plastic & Reconstructive Surgeon, Mumbai";
const DOMAIN = "https://drvickyjain.com";
const OG_IMAGE = `${DOMAIN}/dr-jain.avif`;
const DEFAULT_DESCRIPTION =
  "Dr. Vicky Jain – Board-certified plastic and reconstructive surgeon in Mumbai. Specialising in rhinoplasty, facelift, breast augmentation, liposuction, gynecomastia, hair transplant, and reconstructive surgery. 17+ years of experience.";
const DEFAULT_KEYWORDS =
  "plastic surgeon Mumbai, cosmetic surgery Mumbai, reconstructive surgery Mumbai, Dr. Vicky Jain";

const SEO = ({
  title,
  description,
  canonical,
  ogImage,
  ogType = "website",
  keywords,
  robots,
  jsonLd,
  article,
}) => {
  const fullTitle = title
    ? title.includes("Dr. Vicky Jain")
      ? title
      : `${title} — Dr. Vicky Jain`
    : SITE_NAME;
  const metaDesc = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = canonical ? `${DOMAIN}${canonical}` : null;
  const image = ogImage || OG_IMAGE;
  const metaKeywords = keywords || DEFAULT_KEYWORDS;
  const robotsValue = robots || "index, follow, max-image-preview:large, max-snippet:-1";
  const jsonLdString = jsonLd
    ? typeof jsonLd === "string"
      ? jsonLd
      : JSON.stringify(jsonLd)
    : null;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="robots" content={robotsValue} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {canonicalUrl && <link rel="alternate" hreflang="en-IN" href={canonicalUrl} />}
      {canonicalUrl && <link rel="alternate" hreflang="x-default" href={canonicalUrl} />}

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:site_name" content="Dr. Vicky Jain Plastic Surgery" />
      <meta property="og:locale" content="en_IN" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {ogType === "article" && article?.publishedTime && (
        <meta property="article:published_time" content={article.publishedTime} />
      )}
      {ogType === "article" && article?.modifiedTime && (
        <meta property="article:modified_time" content={article.modifiedTime} />
      )}
      {ogType === "article" && article?.author && (
        <meta property="article:author" content={article.author} />
      )}
      {ogType === "article" && article?.section && (
        <meta property="article:section" content={article.section} />
      )}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={fullTitle} />

      {jsonLdString && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdString }} />
      )}
    </>
  );
};

export default SEO;
